import React from 'react';
import Fab from '@mui/material/Fab';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useScrollTrigger, Zoom } from '@mui/material';

export default function ScrollToTop() {
    // Detect if the page is scrolled (excluding the very top)
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 100, // Show button after 100px of scrolling down
    });

    const handleClick = (event) => {
        const anchor = (event.target.ownerDocument || document).querySelector('#back-to-top-anchor');

        if (anchor) {
            anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };

    return (
        <Zoom in={trigger}>
            <div onClick={handleClick} role="presentation" style={{ position: 'fixed', bottom: 20, right: 20 }}>
                <Fab color="secondary" size="small" aria-label="scroll back to top">
                    <ArrowUpwardIcon />
                </Fab>
            </div>
        </Zoom>
    );
}
